<script lang="ts" setup>
defineProps<{
    title?: string;
}>();
</script>

<template>
    <h1 class="text-2xl font-semibold p-10 min-h-[64px] vertically-center">
        {{ title || "" }}
        <slot />
    </h1>
</template>
